<template>
  <div v-if="sales" class="p-0 col-12 animated fadeIn">
    <div id="accordion">
      <div class="card">
        <div class="card-header" id="headingOne">
          <h5 class="mb-0">
            <button class="btn" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" 
                aria-controls="collapseOne" style="background: transparent !important">
              {{sales.order_code}} / {{sales.customer.name}} / {{sales.logistic.toUpperCase()}}
            </button>
          </h5>
        </div>
        <div id="collapseOne" class="collapse" aria-labelledby="headingOne" data-parent="#accordion">
          <div class="card-body">
            <div class="row m-0">
              <div class="col-6 col-md-3 p-0">Sales Person</div>
              <div class="col-6 col-md-3 p-0 value-field">
                <span class="text-capitalize">{{sales.cs_detail.fullname}}</span>
              </div>
              <div class="col-6 col-md-3 p-0">Sales Type</div><div class="col-6 col-md-3 p-0 value-field">
                <span class="text-uppercase">{{sales.type}}</span>
              </div>
              <div class="col-6 col-md-3 p-0">Channel</div>
              <div class="col-6 col-md-3 p-0 value-field">
                <span class="text-uppercase">{{sales.channel}}</span>
              </div>
              <div class="col-6 col-md-3 p-0">Logistic</div>
              <div class="col-6 col-md-3 p-0 value-field">
                <span class="text-uppercase">{{sales.logistic}}</span>
              </div>
              <hr class="col-12"/>
              <div class="col-12 col-md-6 p-0">
                <table style="width: 100%; border: none">
                  <tr>
                    <td class="px-1 py-2 text-capitalize" width="50%">Customer Name</td>
                    <td class="px-1 py-2 text-capitalize" style="border: none">{{ sales.customer.name.toLowerCase() }}</td>
                  </tr>
                  <tr>
                    <td class="px-1 py-2 text-capitalize">Phone Number</td>
                    <td class="px-1 py-2" style="border: none">{{ sales.customer.phone }}</td>
                  </tr>
                  <tr>
                    <td class="px-1 py-2 text-capitalize">Email</td>
                    <td class="px-1 py-2" style="border: none" v-if="sales.customer.email">{{sales.customer.email}}</td>
                    <td class="px-1 py-2" style="border: none" v-else>-</td>
                  </tr>
                  <tr>
                    <td class="px-1 py-2 text-capitalize">Address</td>
                    <td class="px-1 py-2 text-capitalize" style="border: none">{{ sales.customer.address.toLowerCase() }}<br/>({{ sales.customer.notes }})</td>
                  </tr>
                  <tr>
                    <td class="px-1 py-2 text-capitalize">Bank Account</td>
                    <td class="px-1 py-2 text-capitalize" style="border: none">{{ sales.account_name.toLowerCase() }}</td>
                  </tr>
                  <tr>
                    <td class="px-1 py-2 text-capitalize">Payment Time</td>
                    <td class="px-1 py-2 text-capitalize" style="border: none"> {{ sales.payment_time }} </td>
                  </tr>
                </table>
              </div>
              <hr class="col-12 d-md-none"/>
              <div class="col-12 col-md-6 p-0">
                <table style="width: 100%; border: none">
                  <tr v-for="(cart, index) in sales.cart" :key="index">
                    <td class="px-1 py-2 text-capitalize" width="50%"> {{ cart.product.name.toLowerCase() }}<strong>{{cart.qty}}</strong> {{ cart.product.unit }}</td>
                    <td class="px-1 py-2" style="border: none">{{ kendo.toString(cart.product.price * cart.qty, 'c') }}</td>
                  </tr>
                  <tr>
                    <td class="px-1 py-2 text-capitalize">Shipping Cost</td>
                    <td class="px-1 py-2" style="border: none">{{ kendo.toString(sales.cost.shipment, 'c') }}</td>
                  </tr>
                  <tr>
                    <td class="px-1 py-2 text-capitalize">Total Discount</td>
                    <td class="px-1 py-2" style="border: none">{{ kendo.toString(Number(sales.discounts), 'c') }}</td>
                  </tr>
                </table>
              </div>
              <hr class="col-12"/>
              <div class="col-6 offset-0 col-md-3 offset-md-6 p-0 text-uppercase"><strong>Final Price</strong></div>
              <div class="col-6 col-md-3 p-0">
                <strong>{{ kendo.toString(Number(sales.price), 'c') }}</strong>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card-body">
        <div class="form">
          <div class="form-group row">
            <label class="col-6 col-md-4 col-lg-3">Document Code</label>
            <div class="col-6 col-md-8 col-lg-9 p-0">
              <input type="text" class="form-control" placeholder="Document Number" v-model="shipping.document">
              <small v-bind:class=" { 'd-none': verification.document } " class="form-feedback error">This field is required</small>
            </div>
          </div>
          <div class="form-group row">
            <label class="col-6 col-md-4 col-lg-3">Pickup Date</label>
            <div class="col-8 col-md-5 p-0">
              <kendo-datepicker class="form-control" v-model="shipping.date" format="yyyy-MM-dd"></kendo-datepicker>
              <small v-bind:class=" { 'd-none': verification.datetime } " class="form-feedback error">This field is required</small>
            </div>
            <div class="d-none d-md-block offset-md-0 col-md-3" style="padding-right: 0px;">
              <kendo-timepicker format="HH:mm" class="form-control" v-model="shipping.time"></kendo-timepicker>
            </div>
          </div>
        </div>
      </div>
      <div class="card-footer text-right">
        <button class="btn btn-primary" @click="submit"><i class="fa fa-save"></i>&nbsp;SUBMIT</button>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  data () {
    return {
      // data here
      kendo: window.kendo,
      sales: null,
      shipping: {
        document: null,
        date: null,
        time: null,
        logistic: null,
        price: null
      },
      verification: {
        document: true,
        datetime: true
      }
    }
  },
  created () {
    this.getSalesData()
  },
  methods: {
    getSalesData () {
      var uid = this.$route.params.uid
      var vm = this
      vm.axios.get('api/sales/logs/' + uid + '/')
        .then(
          (response) => {
            console.log(response)
            var data = response.data
            vm.sales = data
            vm.shipping.logistic = vm.sales.logistic
            vm.shipping.price = vm.sales.cost.shipment
            if (vm.sales.shipping.length > 0) {
              vm.shipping.document = vm.sales.shipping[0].document_code
              var date = moment(vm.sales.shipping[0].pickup_time, 'YYYY-MM-DD HH:mm:ss+-HH')
              vm.shipping.date = date.format('YYYY-MM-DD')
              vm.shipping.time = date.format('HH:mm')
            }
            console.log(vm.shipping)
          }
        )
        .catch(
          (error) => {
            console.log(error)
            vm.$router.push('Four Oh Four')
          }
        )
    },
    submit () {
      if (this.verify()) {
        // do submit here
        var vm = this
        var data = new URLSearchParams()
        data.append('sales', vm.sales.uid)
        data.append('logistic', vm.shipping.logistic)
        data.append('document_code', vm.shipping.document)
        // set up time
        var timezone = new Date().getTimezoneOffset()
        var tz = parseInt(Math.abs(timezone) / 60).toString()
        if (tz.length === 1) {
          tz = '0' + tz
          if (timezone < 0) {
            tz = '-' + tz
          } else {
            tz = '+' + tz
          }
        }
        data.append('pickup_time', vm.shipping.date + ' ' + vm.shipping.time + ':00' + tz)
        vm.axios.post('api/inventory/shipping/', data)
          .then(
            (response) => {
              console.log(response)
              vm.$parent.showNotification('Shipping Updated for Sales ' + vm.sales.order_code, 'success')
              var page = 1
              if ('return' in vm.$route.query) {
                page = vm.$route.query.return
              }
              vm.$router.push('/sales?page=' + page)
            }
          )
          .catch(
            (error) => {
              console.log(error.response)
              vm.$parent.showNotification('Oops! Unable to remove data at this moment. Please try again later!', 'danger')
            }
          )
      }
    },
    verify () {
      if (this.shipping.document === null || (this.shipping.document && this.shipping.document.length === 0)) {
        this.verification.document = false
        return false
      } else {
        this.verification.document = true
      }
      if (this.shipping.date === null || (this.shipping.date && this.shipping.date.length === 0)) {
        this.verification.datetime = false
        return false
      } else if (this.shipping.time === null || (this.shipping.time && this.shipping.time.length === 0)) {
        this.verification.datetime = false
        return false
      } else {
        this.verification.datetime = true
      }
      return true
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/shipping/Shipping.vue